import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeableImageComponent } from './components/changeable-image/changeable-image.component';
import { PackageDetailedDescriptionDialogComponent } from './components/package-detailed-description-dialog/package-detailed-description-dialog.component';
import { JoinArrayStringPipe } from './pipes/join-array-string-pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { OpenableYoutubeVideoPreviewComponent } from './components/openable-youtube-video-preview/openable-youtube-video-preview.component';
import { YoutubeVideoDialogComponent } from './components/youtube-video-dialog/youtube-video-dialog.component';
import { SafePipe } from './pipes/safe.pipe';
import { YoutubePlayerComponent } from './components/youtube-player/youtube-player.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { MatTooltipClickableDirective } from './components/mat-tooltip-clickable.directive';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  declarations: [
    ChangeableImageComponent,
    JoinArrayStringPipe,
    SafePipe,
    PackageDetailedDescriptionDialogComponent,
    ConfirmationDialogComponent,
    OpenableYoutubeVideoPreviewComponent,
    YoutubeVideoDialogComponent,
    YoutubePlayerComponent,
    MatTooltipClickableDirective
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    YouTubePlayerModule,
    MatIconModule
  ],
  exports: [
    ChangeableImageComponent,
    JoinArrayStringPipe,
    PackageDetailedDescriptionDialogComponent,
    OpenableYoutubeVideoPreviewComponent,
    YoutubeVideoDialogComponent,
    YoutubePlayerComponent,
    SafePipe,
    MatTooltipClickableDirective
  ]
})
export class SharedModule { }
